import React from "react";

// Mini-site wrapper: sets full page background + CSS vars from the project logo palette
export const MiniSite = ({ theme, children }) => (
  <div
    className={`relative ${theme.light ? "ms-light" : "text-white"}`}
    style={{
      "--ms-bg": theme.bg,
      "--ms-surface": theme.surface,
      "--ms-accent": theme.accent,
      "--ms-accent2": theme.accent2 || theme.accent,
      backgroundColor: theme.bg,
    }}
  >
    {children}
  </div>
);

// Faint basketball half-court lines
export const CourtLines = ({ className = "", opacity = 0.07 }) => (
  <svg
    className={`absolute pointer-events-none select-none ${className}`}
    style={{ opacity }}
    viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
  >
    <circle cx="400" cy="400" r="120" stroke="white" strokeWidth="2" />
    <circle cx="400" cy="400" r="10" fill="white" />
    <line x1="0" y1="400" x2="800" y2="400" stroke="white" strokeWidth="2" />
    <rect x="280" y="0" width="240" height="190" stroke="white" strokeWidth="2" />
    <path d="M280 190 A 120 120 0 0 0 520 190" stroke="white" strokeWidth="2" />
    <path d="M80 0 A 340 340 0 0 0 720 0" stroke="white" strokeWidth="2" />
    <rect x="280" y="610" width="240" height="190" stroke="white" strokeWidth="2" />
    <path d="M280 610 A 120 120 0 0 1 520 610" stroke="white" strokeWidth="2" />
    <path d="M80 800 A 340 340 0 0 1 720 800" stroke="white" strokeWidth="2" />
  </svg>
);

const PlaneIcon = ({ size = 18, className = "", style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} style={style} aria-hidden="true">
    <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5Z" />
  </svg>
);
export { PlaneIcon };

// Dotted flight route divider with a plane
export const FlightDivider = ({ className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`} aria-hidden="true">
    <span className="flex-1 border-t-2 border-dashed border-white/15" />
    <PlaneIcon size={20} className="text-white/40 rotate-90" />
    <span className="flex-1 border-t-2 border-dashed border-white/15" />
  </div>
);

// Passport stamp
export const Stamp = ({ top, bottom, className = "", color = "rgba(255,255,255,0.85)" }) => (
  <div className={`stamp font-mono uppercase ${className}`} style={{ borderColor: color, color }}>
    <span className="text-[8px] tracking-[0.2em] leading-tight">{top}</span>
    <span className="text-[13px] font-bold tracking-[0.12em] leading-tight">{bottom}</span>
  </div>
);

export const Barcode = ({ className = "", vertical = false }) => (
  <div className={`${vertical ? "barcode-v" : "barcode"} ${className}`} aria-hidden="true" />
);

export const MonoTag = ({ children, className = "", style }) => (
  <span className={`font-mono text-[10px] md:text-[11px] uppercase tracking-[0.3em] ${className}`} style={style}>
    {children}
  </span>
);

// Giant ghost background typography
export const GhostText = ({ text, className = "" }) => (
  <span
    className={`absolute font-display uppercase leading-none text-white/[0.05] select-none pointer-events-none whitespace-nowrap ${className}`}
    aria-hidden="true"
  >
    {text}
  </span>
);
